import React from "react";
import CenteredLoadingIcon from "../../common_components/CenteredLoadingIcon";
import MissionPriceQuotesAPI from "../../../api/api_calls/MissionPriceQuotesAPI";


function PriceDisplay(props) {

    // We get price as a string. It could either be "-" or a number (in string form).
    // If it's a number, we convert it to a float and display it with 2 decimal places.
    // If it's "-", we display it as is.
    const formattedPrice = props.price === "-" ? props.price : parseFloat(props.price).toFixed(2);
    const formattedTotalPrice = props.totalPrice === "-" ? props.totalPrice : parseFloat(props.totalPrice).toFixed(2);

    return (
        <div className="price-display-container">
            {!props.price ? <CenteredLoadingIcon /> :
                <>
                    <div className="price-display-row">
                        <div className="price-display-text">
                            Price per session
                        </div>
                        <div className="price-display-price">
                            ${formattedPrice}
                        </div>
                    </div>
                    <div className="price-display-divider" />
                    <div className="price-display-row">
                        <div className="price-display-text">
                            Total
                        </div>
                        <div className="price-display-price">
                            ${formattedTotalPrice}
                        </div>
                    </div>
                </>
            }
        </div>
    )

}

function updatePrice(setPriceFunction, setTotalPriceFunction, missionId, navigate, alert) {
    async function createMissionPriceQuote() {
        const result = await MissionPriceQuotesAPI.create({ missionId, navigate });

        if (result.success) {
            setPriceFunction(result.price);
            setTotalPriceFunction(result.total_price);
        } else {
            alert.show(result.error, { type: 'error' })
            setPriceFunction(null);
            setTotalPriceFunction(null);
        }
    }

    createMissionPriceQuote();
}

export { PriceDisplay, updatePrice };